// extracted by mini-css-extract-plugin
export default {"tuLogo":"TuHeader_tuLogo__wE+AT"};